import React from 'react';
import { CloseIcon } from '@chakra-ui/icons';
import { Box, Modal, ModalContent, ModalOverlay, Text } from '@chakra-ui/react';

interface CommonProps {
  title: string;
  open: boolean;
  handleClose: () => void;
  children?: React.ReactChild;
  width?: any;
}

function Index({ handleClose, open, title, children, width }: CommonProps) {
  return (
    <>
      <Modal isCentered isOpen={open} onClose={handleClose}>
        <ModalOverlay />
        <ModalContent sx={modalStyle}>
          <Box sx={boxStyle}>
            <Text sx={titleStyle}>{title}</Text>
            <CloseIcon w={4} h={4} cursor={'pointer'} onClick={handleClose} />
          </Box>

          <Box>{children}</Box>
        </ModalContent>
      </Modal>
    </>
  );
}

export default Index;
const modalStyle = {
  width: { sm: '95%', md: '70%', lg: 560 },
  padding: '40px 40px 0px 40px',
  borderRadius: 12,
  maxWidth: 'auto',
};

const boxStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  paddingBottom: 6,
  borderBottom: '1px solid ',
  marginBottom: 8,
  borderColor: 'secondaryGray.600',
};
const titleStyle = { fontSize: 20, fontWeight: 500, lineHeight: '24.2px' };
